@if (show) {
  <div class="save-strategy-template-modal" data-cy="save-strategy-template-modal">
    <h1 class="save-strategy-template-modal--title">{{ 'modal.saveStrategyTemplate.title' | translate }}</h1>
    <p class="save-strategy-template-modal--subtitle">{{ 'modal.saveStrategyTemplate.subtitle' | translate }}</p>

    <div class="save-strategy-template-modal--form">
      <div class="save-strategy-template-modal--field save-strategy-template-modal--field--name">
        <label class="save-strategy-template-modal--label">{{ 'draftTemplate.nameLabel' | translate }}</label>
        <div
          class="save-strategy-template-modal--text-input-container"
          [class.save-strategy-template-modal--text-input-container--invalid]="nameControl.touched && nameControl.invalid"
        >
          <input
            class="save-strategy-template-modal--text-input"
            [formControl]="nameControl"
            (input)="nameControl.markAsTouched()"
            data-cy="save-strategy-template-name-input"
          >
        </div>
        <div class="save-strategy-template-modal--text-placeholder">
          @if (nameInvalidText && nameControl.touched && nameControl.invalid) {
            <div class="save-strategy-template-modal--invalid-input-text">
              {{ nameInvalidText | translate }}
            </div>
          }
        </div>
      </div>

      <div class="save-strategy-template-modal--field">
        <div class="save-strategy-template-modal--label-row">
          <label class="save-strategy-template-modal--label">{{ 'draftTemplate.colorLabel' | translate }}</label>
          <libero-tooltip-button [hidePerson]="true">
            {{ 'draftTemplate.colorTooltip' | translate }}
          </libero-tooltip-button>
        </div>
        <div class="save-strategy-template-modal--color-options" role="radiogroup" [attr.aria-label]="'draftTemplate.colorLabel' | translate">
          @for (color of colorOptions; track color) {
            <button
              type="button"
              class="save-strategy-template-modal--color-option"
              [class.save-strategy-template-modal--color-option--selected]="isColorSelected(color)"
              [attr.aria-checked]="isColorSelected(color)"
              role="radio"
              (click)="selectColor(color)"
            >
              <span class="save-strategy-template-modal--color-swatch" [style.background-color]="color"></span>
            </button>
          }
        </div>
      </div>

      <div class="save-strategy-template-modal--field">
        <button
          type="button"
          class="save-strategy-template-modal--description-toggle"
          (click)="toggleDescription()"
          [attr.aria-expanded]="descriptionExpanded"
        >
          <span class="save-strategy-template-modal--label">{{ 'draftTemplate.descriptionLabel' | translate }}</span>
          <svg-icon
            src="assets/icons/chevron-down.svg"
            [svgStyle]="{ 'width.px': 18, 'transform': descriptionExpanded ? 'rotate(180deg)' : '', 'fill': '#858585' }"
          ></svg-icon>
        </button>

        @if (descriptionExpanded) {
          <div
            class="save-strategy-template-modal--description-panel"
            [class.save-strategy-template-modal--description-panel--invalid]="descriptionControl.touched && descriptionControl.invalid"
          >
            <textarea
              class="save-strategy-template-modal--description-textarea"
              [value]="descriptionControl.value ?? ''"
              (input)="onDescriptionInput($event)"
              data-cy="save-strategy-template-description-input"
            ></textarea>
            @if (descriptionControl.hasError('maxlength')) {
              <p class="save-strategy-template-modal--description-error">
                {{ 'draftTemplate.descriptionMaxLength' | translate: { max: descriptionMaxLength } }}
              </p>
            }
          </div>
        }
      </div>
    </div>

    <div class="save-strategy-template-modal--actions">
      <libero-button
        label="{{ 'global.buttons.back' | translate }}"
        btnClasses="icon--secondary btn--icon-text"
        (click)="backBtnClick.emit()"
        data-cy="save-strategy-template-back-btn"
      ></libero-button>
      <libero-button
        label="{{ 'draftTemplate.createTemplate' | translate }}"
        btnClasses="btn--primary btn--heading btn--s-20"
        [buttonDisabled]="saving"
        [preloader]="saving"
        (click)="onCreateTemplate()"
        data-cy="save-strategy-template-create-btn"
      ></libero-button>
    </div>
  </div>
}
